export const LOAD_LIST_ONLINE_SERVICE = 'booking/LOAD_LIST_ONLINE_SERVICE';
export const LOAD_LIST_ONLINE_SERVICE_SUCCESS =
  'booking/LOAD_LIST_ONLINE_SERVICE_SUCCESS';
export const LOAD_LIST_ONLINE_SERVICE_ERROR =
  'booking/LOAD_LIST_ONLINE_SERVICE_ERROR';
